// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3qzLl","buttons":"SendReceipts_buttons__3l8Av","email":"SendReceipts_email__3mJlQ","bookApptTitle":"SendReceipts_bookApptTitle__2-Sdr"};